// extracted by mini-css-extract-plugin
export default {"ProjectsList":"ProjectExamples_ProjectsList__0R6YW","AlignCenter":"ProjectExamples_AlignCenter__zDS1q","Button":"ProjectExamples_Button__Y-p8o"};